export default "__VITE_ASSET__26204635__"